<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8cz0Qx/images/9781439674390.jpg?1684306037840" alt="This image is the cover for the book Babies Hospital of New York, Images of America"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Babies Hospital of New York, Images of America
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The Babies Hospital, now known as Morgan Stanley Children's Hospital, was founded in 1887 by Drs. Sarah and Julia McNutt in a brownstone on Fifty-Fifth Street and Lexington Avenue.</b></p><p>The hospital is the first freestanding children's hospital in New York City and the fourth oldest in the United States. However, the hospital traces its roots to the establishment of the Vagelos College of Physicians and Surgeons of Columbia University, then King's College, more than 250 years ago. In 1929, the hospital relocated to a new 204-bed facility as part of the Columbia-Presbyterian Medical Center. The <i>New York Times</i> referred to the new Babies Hospital as "the last word in hospital design and equipment." Under the leadership of Rustin Mcintosh from 1931 to 1960, the hospital became a beacon for discovery and innovation, assembled a department of noted subspecialists, and was one of the first children's hospitals to develop programs in neonatology, surgery, radiology, neurology, hematology-oncology, and psychiatry.</p><p>Michael Weiner, MD, Hettinger professor of pediatrics at Columbia University Irving Medical Center, is a vice chair of pediatrics, former director of the Division of Pediatric Oncology, and an author of <i>Living Cancer: Stories of an Oncologist, Father, Survivor and a Philanthropist</i>. Stephen E. Novak has been the head of Archives &amp; Special Collections at Columbia's Augustus C. Long Health Sciences Library since 1997. The images in the book come from the rich photographic resources of the library.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Michael Weiner, Stephen E. Novak, PhD
      </h2>
      
      <p class="authorDescription body article">Michael Weiner, MD, Hettinger professor of pediatrics at Columbia University Irving Medical Center, is a vice chair of pediatrics, former director of the Division of Pediatric Oncology, and an author of Living Cancer: Stories of an Oncologist, Father, Survivor and a Philanthropist. Stephen E. Novak has been the head of Archives & Special Collections at Columbia's Augustus C. Long Health Sciences Library since 1997. The images in the book come from the rich photographic resources of the library.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5c024574